import { getCurationSnaps as getCurationSnapsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import type {
  GetCurationSnapsServiceRequest,
  GetCurationSnapsServiceResponse,
} from './get-curation-snaps.dto';
import {
  GetCurationSnapsServiceRequestSchema,
  GetCurationSnapsServiceResponseSchema,
} from './get-curation-snaps.dto';
export const getCurationSnapsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCurationSnapsServiceRequestSchema),
    async (request: GetCurationSnapsServiceRequest): Promise<GetCurationSnapsServiceResponse> => {
      const apiResponse = await getCurationSnapsApi({
        curationId: request.curationId,
        page: request.page,
        size: request.size,
        snapId: request.snapId ?? undefined,
      });

      const { data } = apiResponse;
      const hasNextFromLink =
        apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const hasNextFromPageSize = data.list.length >= request.size;
      const hasNextPage = hasNextFromLink || hasNextFromPageSize;

      const linkTotal =
        apiResponse.link && typeof apiResponse.link === 'object' && 'total' in apiResponse.link
          ? (apiResponse.link as { total?: number }).total
          : undefined;
      const total = linkTotal ?? 0;

      return {
        curationId: data.curationId,
        title: data.title,
        description: data.description,
        list: data.list.map((snap) => ({
          id: String(snap.id),
          imageUrls:
            snap.imageUrls && snap.imageUrls.length > 0
              ? snap.imageUrls
              : snap.imageUrl
                ? [snap.imageUrl, snap.imageUrl]
                : [],
          linkUrl: snap.linkUrl,
          goods: snap.goods.map((g) => ({
            goodsNo: String(g.goodsNo),
            goodsName: g.goodsName,
            brandId: g.brandId,
            brandName: g.brandName,
            brandLinkUrl: g.brandLinkUrl,
            linkUrl: g.linkUrl,
            imageUrl: g.imageUrl,
            normalPrice: g.normalPrice,
            price: g.price,
            couponPrice: g.couponPrice,
            couponSalesRate: g.couponSalesRate,
            extraDiscountAmount: g.extraDiscountAmount ?? 0,
            finalPrice: g.finalPrice ?? g.couponPrice ?? g.price,
            finalDiscount: g.finalDiscount ?? g.couponSalesRate ?? g.salesRate ?? 0,
            isLowestPrice: g.isLowestPrice ?? false,
            isExclusive: g.isExclusive ?? false,
            salesRate: g.salesRate,
            isLiked: g.isLiked,
            isSoldOut: g.isSoldOut,
            hasOptionPrice: g.hasOptionPrice,
          })),
        })),
        total,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage: hasNextPage ? request.page + 1 : undefined,
        },
      };
    },
    validateServiceResponse(GetCurationSnapsServiceResponseSchema),
  ),
);
